/**
 * Sites registry hook — SPA architectural convergence plan §6.3.
 *
 * Replaces the Phase-0 `zenoh-bridge`-driven Zenoh discovery path.
 * The convergence target sources the site list from the global
 * `nexsoss-api-server` (`GET /api/v1/sites`), which returns only the
 * sites the caller is assigned to per the SQL `user_site_assignments`
 * table. The SPA MUST NOT maintain its own site list; assignment
 * removal aborts streams, clears site caches, and reconciles
 * selection (plan §6.3).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchAssignedSites } from '../v1-client';
import type { SiteSummary } from '../v1';

export const SITES_QUERY_KEY = ['v1', 'sites'] as const;

export function useSites() {
  return useQuery<SiteSummary[]>({
    queryKey: SITES_QUERY_KEY,
    queryFn: () => fetchAssignedSites(),
    staleTime: 60_000,
  });
}